import SeamlyBaseError from './seamly-base-error'

/**
 * This error is used to alert the user that there's a problem with the connection
 * when initialising the application because of a connection issue on either the server
 * or the client side.
 */
export default class SeamlyUnavailableError extends SeamlyBaseError {
  constructor(originalError?: any, ...params) {
    super(originalError, ...params)

    this.name = 'SeamlyUnavailableError'
    this.langKey = 'errors.seamlyUnavailable'
  }
}
